import React, { Component } from 'react';
import './Step.scss';

export default class Step extends Component {
  render() {
    const classNames =  [
      'step_bar__step',
      this.props.active ? "active" : "",
      this.props.done  ? "done" : "",
    ];

    return (
      <li className={classNames.join(" ").trim()}>
          <span>
            {this.props.inner}
          </span>

        {
          this.props.status === "done" ? (
            <i className="icon icon-check">
            </i>
          ) : null
        }
      </li>
    )
  }
}
